import { render, staticRenderFns } from "./ViewMorePhotoModal.vue?vue&type=template&id=fb8b4c20"
import script from "./ViewMorePhotoModal.vue?vue&type=script&lang=js"
export * from "./ViewMorePhotoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports